import gql from 'graphql-tag';
import React, { useState } from 'react';
import { Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { useLocation } from 'react-router';
import emailSentIcon from '../../images/email-sent.svg';
import TorontoFooter from '../Layout/TorontoFooter';
import Dropdown from '../shared/Dropdown';
import Loading from '../shared/Loading';
import { useHistory } from 'react-router-dom';
import SFFooter from '../Layout/SFFooter';
import OttawaFooter from '../Layout/OttawaFooter';
import NYCFooter from '../Layout/NYCFooter';

const ContactEmail = ({ client }) => {
  const history = useHistory();
  const pathname = history.location.pathname;
  const [first, setFirst] = useState();
  const [last, setLast] = useState();
  const [email, setEmail] = useState();
  const [subject, setSubject] = useState();
  const [msg, setMsg] = useState();
  const [isSent, setIsSent] = useState();
  const [loading, setLoading] = useState();
  const [toSubmit, setToSubmit] = useState();
  const [curDrive, setCurDrive] = useState();

  const allCityOptions = [
    { name: 'Toronto', value: 'toronto' },
    { name: 'New York', value: 'new_york' },
    { name: 'San Francisco', value: 'san_francisco' },
    { name: 'Los Angeles', value: 'los_angeles' },
    { name: 'Ottawa', value: 'ottawa'}
  ];

  const triggerDriveCity = childData => {
    setCurDrive(childData);
  };

  const triggerFirst = e => {
    setFirst(e.target.value);
  };

  const triggerLast = e => {
    setLast(e.target.value);
  };
  const triggerEmail = e => {
    setEmail(e.target.value);
  };

  const triggerSubject = e => {
    setSubject(e.target.value);
  };

  const triggerMsg = e => {
    setMsg(e.target.value);
  };

  const toggleEmailSent = () => {
    setIsSent(!isSent);
  };

  const toggleToSubmit = () => {
    setToSubmit(!toSubmit);
  };

  const SEND_EMAIL = gql`
    mutation sendEmailFromNewUser(
      $emailMessageArgs: EmailMessageAttributes!
    ) {
      sendEmailFromNewUser(emailMessageArgs: $emailMessageArgs) {
        message {
          userId
          subject
        }
      }
    }
  `;
  const handleSendEmail = () => {
    // e.preventDefault();
    setLoading(true);
    client
      .mutate({
        mutation: SEND_EMAIL,
        variables: {
          emailMessageArgs: {
            name: first + ' ' + last,
            email: email,
            subject: subject,
            message: msg,
            operatingCity: curDrive
          }
        }
      })
      .then(res => {
        if (res.data.sendEmailFromNewUser.message) {
          setLoading(false);
          toggleEmailSent();
          console.log('Email submit successful!');
        } else console.log('Email submit error!');
      });
  };

  const ableToSubmit = first && last && email && subject && msg && curDrive;
  const emailInvalid = !(email && email.includes('@'));
  const cityInvalid = !(curDrive)
  const isMobile = window.innerWidth < 768;

  return (
    <Fragment>
      {isSent ? (
        <div
          className="signup-form-container"
          style={{ width: isMobile ? '400px' : '800px' }}>
          <img src={emailSentIcon} />
        </div>
      ) : loading ? (
        <Loading size="3x" />
      ) : (
        <div className="signup-form-container">
          <div className="form-title">Email</div>
          <div className="input-field">
            <div className="floating-label">First name</div>
            <input
              className="input-container"
              onChange={triggerFirst}
              value={first}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Last name</div>
            <input
              className="input-container"
              onChange={triggerLast}
              value={last}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Email</div>
            <input
              className="input-container"
              onChange={triggerEmail}
              value={email}></input>
            {toSubmit && emailInvalid && (
              <span style={{ color: '#ff0000' }}>
                Invalid email address
              </span>
            )}
          </div>
          <div className="input-field">
            <div className="floating-label">Subject</div>
            <input
              className="input-container"
              onChange={triggerSubject}
              value={subject}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">City</div>
            <Dropdown
              initialValue={curDrive}
              items={allCityOptions}
              onChange={triggerDriveCity}
              width={isMobile ? '327px' : '600px'}
              height="40px"
              optionWidth={isMobile ? '327px' : '600px'}
              borderColor={'#dedede'}
            />
            {toSubmit && cityInvalid && (
              <span style={{ color: '#ff0000' }}>
                Choose a city
              </span>
            )}
          </div>
          <div className="input-field">
            <div className="floating-label">Message</div>
            <textarea
              className="input-container-msg"
              onChange={triggerMsg}
              value={msg}></textarea>
          </div>
          <button
            className="signup-button"
            style={{ background: ableToSubmit ? '#128dff' : '#87caef' }}
            onClick={() => {
              toggleToSubmit();
              ableToSubmit && !emailInvalid && handleSendEmail();
            }}>
            Submit
          </button>
        </div>
      )}
      {pathname.includes('tor') ? (
        <TorontoFooter />
      ) : pathname.includes('sf') ? (
        <SFFooter />
      ) : pathname.includes('ott') ? (
        <OttawaFooter />
      ) : (
        <NYCFooter />
      )}
    </Fragment>
  );
};

export default withApollo(ContactEmail);



// WEBPACK FOOTER //
// ./src/components/NewContact/ContactEmail.js